import { MutationCache, QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from 'sonner';

import { MESSAGE } from '@/lib/constants';
import { capitalizeFirstLetter } from '@/lib/utils';

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      let message = MESSAGE.ERROR;

      if (mutation.meta?.errorMessage) {
        message = mutation.meta.errorMessage;
      } else if (error instanceof AxiosError && error.response?.data?.context) {
        message = error.response.data.context[0];
      } else if (
        error instanceof AxiosError &&
        error.response?.status === 403 &&
        error.response?.data?.message
      ) {
        message = error.response.data.message;
      } else if (error instanceof AxiosError && error.response?.status === 404) {
        message = 'Not found, or you do not have permission to do this.';
      } else if (error instanceof AxiosError && error.response?.status === 409) {
        message = 'This already exists.';
      } else if (error instanceof Error && error.message) {
        message = error.message;
      }

      toast.error(capitalizeFirstLetter(message));
    },
    onSuccess: (_data, _variables, _context, mutation) => {
      queryClient.invalidateQueries();

      if (mutation.meta?.successMessage) {
        toast.success(mutation.meta.successMessage);
      }
    },
  }),
});
